import { createUseStyles } from 'react-jss'
import colors from 'src/config/colors'
import { shadows } from 'src/config/styles'

export default createUseStyles({
  root: {
    background: colors.white,
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    maxWidth: '248px',
    boxShadow: shadows[2],
    overflowY: 'auto',
    zIndex: 20,
  },
})
